export default __webpack_public_path__ + "static/media/Card-Img.63f07c49.png";